
class ButtonSelector extends HTMLElement {
    constructor() {
      super();
        this.inputs = this.querySelectorAll('input');
        this.selectInputs = document.querySelectorAll('.content-form select[id^="variant-selector"] option');
        this.quantitySelector = document.querySelector('.quantity-selector');

        this.checkVisibility();

        this.inputs.forEach(input => {
            input.addEventListener('change', (e) => {
                for (let i = 0; i < this.inputs.length; i++) {
                    const input = this.inputs[i];
                    input.nextElementSibling.classList.remove('selected');
                }

                for (let i = 0; i < this.selectInputs.length; i++) {
                    const selectInput = this.selectInputs[i];
                    selectInput.removeAttribute('selected');

                    if(e.target.id == selectInput.value) {
                        e.target.nextElementSibling.classList.add('selected');
                        selectInput.selected = true;
                        selectInput.parentElement.value = selectInput.value;
                        const event = new Event('change', { bubbles: true });
                        selectInput.parentElement.dispatchEvent(event);
                    }
                }
            }   
                
        )
        });
    }

    // This should be removed when A/B test is done.
    // Move logic to hide parent element into the main component.
    checkVisibility() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (this.quantitySelector) {
                        this.quantitySelector.remove();
                    }
                    if (this.inputs.length < 2) {
                        this.parentElement.style.display = 'none';
                    }
                    observer.disconnect();
                }
            });
        });
        observer.observe(this);
    }
}

customElements.define('button-selector', ButtonSelector);
